/** JSON with object keys sorted recursively, used to compare command contents (D7). */
export const canonicalJson = (value) => JSON.stringify(value, (_key, item) => item !== null && typeof item === 'object' && !Array.isArray(item)
    ? Object.fromEntries(Object.entries(item).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0))
    : item);
//# sourceMappingURL=canonical-json.js.map